














































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import MonthSelectorVue from "../components/MonthSelector.vue";
import InvoicePreVue from "../components/IntelligentVoucherList/InvoicePre.vue"
import EnvidenceVue from "../components/IntelligentVoucherList/Envidence.vue"
import envidenceVue from "../components/VoucherList/envidence.vue";
import SzTypes from "../data/SzTypes";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "month-selector": MonthSelectorVue,
        "invoice-pre": InvoicePreVue,
        "envidence": EnvidenceVue,
        "envidences": envidenceVue
    }
})
export default class IntelligentVoucherList extends Vue {
    clazz: number = 0;
    cannotEdit: boolean = false
    checkAll: boolean = false; //是否全选
    cate: string = ""
    filterVisible: boolean = false;
    businessTypeList = SzTypes.list
    fpList:any = [
        {
            title:"普票",
            id:"0"
        },
        {
            title:"专票",
            id:"1"
        }
    ]
    businessType: any = "";
    invoiceType:any = ""
    invoiceVisible: boolean = false
    resetFilter() {
        this.businessType = ""
        this.searchQuery = ""
        this.invoiceType = ""
        this.fetchData();
        this.filterVisible = false;
        this.invoiceVisible = false
    }
    confirmFilter() {
        this.fetchData();
        this.filterVisible = false;
        this.invoiceVisible = false;
    }
    mounted() {
        this.clazz = Number(this.$route.query.class);
        if (!this.$utils.canControl()) {
            this.cannotEdit = true;
        } else {
            this.cannotEdit = false;
        }
    }
    // 原始凭证
    enitem:any = ""
    showOrg:boolean = false
    showAccessory(item:any) {
        if(item.length >0 && this.clazz === 0){
            this.enitem = {
                invoiceDtos:item
            }
            this.showOrg = true
        }
    }
    //分页
    currentPage: number = 1;
    pageSize: number = 50;
    totalElements: number = 0;
    handleCurrentChange(val: number) {
        this.currentPage = val;
        this.searchQuery = "";
        this.fetchData();
    }
    //改变时间
    period: String[] = []; // 日期
    changeDate(date: string[]) {
        this.period = date;
        this.fetchData();
    }
    //选中每页条数
    changeSize(size: number) {
        this.pageSize = size;
        this.fetchData();
    }
    // 区分当前状态type
    getType() {
        if (this.clazz === 0) return "invoice";
        else if (this.clazz === 1) return "dayAccount";
        else if (this.clazz === 2) return "others";
        else return "salaryList"
    }
    // 获取title的格式
    getTitle() {
        if (this.clazz === 0) return "发票";
        else if (this.clazz === 1) return "日记账";
        else if (this.clazz === 2) return "其他票据";
        else return "工资表";
    }
    // 切换凭证列表
    changeClazz(num: number) {
        this.clazz = num;
        this.handleCurrentChange(1);
    }
    // 获取数据
    list: Voucher.Voucher[] = []
    fetchData() {
        if (this.clazz === 1) {
            this.cate = "4"
            this.getDayAccount();
        } else if (this.clazz === 0) {
            if (this.purchase === true) this.cate = "2"
            else this.cate = "3"
            this.getInvoices();
        } else if (this.clazz === 2) {
            this.cate = "5"
            this.getOthers();
        } else {
            this.cate = ""
            this.getSalaryList();
        }
    }
    // 日记账数据
    getDayAccount() {
        this.list = [];
        let incomePayType = ""
        if (this.businessType !="") incomePayType = this.businessType.id
        Vue.axios
            .get(
                `journals/vouchers?period=${this.period}&accountBookId=${this.$store.state.accountBook.id}&page=${this.currentPage - 1}&size=${this.pageSize}&query=${this.searchQuery}&incomePayType=${incomePayType}`)
            .then(res => {
                this.totalElements = res.data.totalElements;
                res.data.content.forEach((v: any) => {
                    v.checked = true;
                })
                this.list = res.data.content;
                this.$nextTick(() => {
                    this.selectAll(false);
                })
                this.isMerge = this.getMerge("journals");
            })
    }
    //增值税票
    getInvoices() {
        this.list = [];
        Vue.axios
            .get(
                `invoice/vouchers?period=${this.period}&accountBookId=${this.$store.state.accountBook.id}&page=${this.currentPage - 1}&size=${this.pageSize}&isProviderOrCustomer=${this.purchase ? 0 : 1}&query=${this.searchQuery}&invoiceType=${this.invoiceType}`)
            .then(res => {
                this.totalElements = res.data.totalElements;
                res.data.content.forEach((v: any) => {
                    v.checked = true;
                })
                this.list = res.data.content;
                this.$nextTick(() => {
                    this.selectAll(false);
                })
                this.isMerge = this.getMerge("invoices");
            })
    }
    //其他票据
    getOthers() {
        this.list = [];
        Vue.axios
            .get(
                `otherinvoices/vouchers?period=${this.period}&accountBookId=${this.$store.state.accountBook.id}&page=${this.currentPage - 1}&size=${this.pageSize}&query=${this.searchQuery}`)
            .then(res => {
                this.totalElements = res.data.totalElements;
                res.data.content.forEach((v: any) => {
                    v.checked = true;
                })
                this.list = res.data.content;
                this.$nextTick(() => {
                    this.selectAll(false);
                })
                this.isMerge = this.getMerge("otherInvoices");
            })
    }
    // 工资表
    salaryTotal: Voucher.Voucher | null = null
    getSalaryList() {
        this.list = [];
        Vue.axios
            .get(
                `paysheet/vouchers?period=${this.period}&accountBookId=${this.$store.state.accountBook.id}&page=${this.currentPage - 1}&size=${this.pageSize}`)
            .then(res => {
                this.totalElements = res.data.totalElements;
                res.data.vouchers.forEach((v: any) => {
                    v.checked = true;
                })
                this.list = res.data.vouchers;
                this.salaryTotal = res.data.total
                this.$nextTick(() => {
                    this.selectAll(false);
                })
            })
    }
    // 全选
    selectAll(val: boolean) {
        for (let i = 0; i < this.list.length; i++) {
            this.list[i].checked = val
        }
    }
    // 滚动
    preTop: number = 0;
    scrollTable(e: any) {
        this.preTop = e.target.scrollTop;
    }
    // 打开  原始凭证
    showOrgDay: boolean = false
    curItem: Voucher.Voucher[] = []
    showEnv(item: Voucher.Voucher[]) {
        this.curItem = item;
        Vue.set(this, "salaryTotal", this.salaryTotal);
        this.showOrgDay = true;
    }
    // 监听list判断是否全选
    @Watch("list", { deep: true })
    listChange(val: Voucher.Voucher[]) {
        let all = false;
        for (let i = 0; i < val.length; i++) {
            if (!val[i].checked) {
                all = false;
                break
            } else {
                all = true;
            }
        }
        this.checkAll = all;
    }

    isSimpleMerge: number = 1;
    changeSimpleMerge(val: number) {
        this.isSimpleMerge = val;
    }
    // 合并凭证
    merge() {
        let checkedVouchers: any = [];
        this.list.forEach((v: Voucher.Voucher) => {
            if (v.checked) checkedVouchers.push(v.id);
        });
        if (checkedVouchers.length <= 1) {
            this.$alert("亲，请至少选择两张凭证！", "温馨提示");
        } else {
            this.$confirm(`亲，是否合并选中的 ${checkedVouchers.length} 条凭证？`, "温馨提示").then((action: any) => {
                if (action === "confirm") {
                    this.mergeRequest(checkedVouchers.join(","));
                }
            })
        }
    }
    mergeRequest(vouchers: any) {
        let PaySheet: string = "";
        if (this.clazz === 0) PaySheet = "Invoice";
        else if (this.clazz === 1) PaySheet = "Journal";
        else if (this.clazz === 2) PaySheet = "OtherInvoice"
        else PaySheet = "PaySheet";
        this.isSimpleMerge = 1;
        if (this.clazz === 0 || this.clazz === 1 || this.clazz === 2 || this.clazz === 3) {
            const h = this.$createElement;
            this.$alert(
                "温馨提示",
                {
                    dangerouslyUseHTMLString: true,
                    message: h("div", {}, [
                        h("input", {
                            attrs: {
                                type: "radio",
                                value: 1,
                                name: "simpleMerge",
                                checked: TextTrackCueList
                            },
                            class: "el-radio__inner",
                            on: {
                                change: () => { this.changeSimpleMerge(1) }
                            }
                        }),
                        h("span", { class: "el-radio__label" }, ["按导入顺序合并"]),
                        h("input", {
                            attrs: {
                                type: "radio",
                                value: 0,
                                name: "simpleMerge"
                            },
                            style: {
                                "margin-left": "15px"
                            },
                            class: "el-radio__inner",
                            on: {
                                change: () => { this.changeSimpleMerge(0) }
                            }
                        }),
                        h("span", { class: "el-radio__label" }, ["按科目明细合并"]),
                        h("input", {
                            attrs: {
                                type: "radio",
                                value: 2,
                                name: "simpleMerge"
                            },
                            style: {
                                "margin-left": "15px"
                            },
                            class: "el-radio__inner",
                            on: {
                                change: () => { this.changeSimpleMerge(2) }
                            }
                        }),
                        h("span", { class: "el-radio__label" }, ["按往来一级科目合并"])
                    ])
                }
            ).then(() => {
                this.mergeApi(vouchers, PaySheet);
            });
        } else {
            this.mergeApi(vouchers, PaySheet);
        }
    }

    mergeApi(vouchers: any, PaySheet: string) {
        Vue.axios
            .post(
                `vouchers/merge?voucherIds=${vouchers}&accountBookId=${this.$store.state.accountBook.id}&accessoryType=${PaySheet}&isSimpleMerge=${this.isSimpleMerge}`, { a: 1 })
            .then(() => { this.fetchData() })
    }
    // 撤销凭证
    cancelMerge() {
        let checkedVouchers: any = [];
        this.list.forEach((v: Voucher.Voucher) => {
            if (v.checked) checkedVouchers.push(v.id);
        });

        this.$confirm(`亲，是否撤销选中凭证的合并？`, "温馨提示").then((action: any) => {
            if (action === "confirm") {
                this.cancelRequest(checkedVouchers.join(","));
            }
        })
    }

    cancelRequest(vouchers: any) {
        let type: string = "";
        if (this.clazz === 0) type = "Invoice";
        else if (this.clazz === 1) type = "Journal";
        else if (this.clazz === 2) type = "OtherInvoice";
        else type = "PaySheet";
        Vue.axios
            .post(
                `vouchers/remerge?voucherIds=${vouchers}&accountBookId=${this.$store.state.accountBook.id}&accessoryType=${type}`, { a: 1 })
            .then(res => { this.fetchData() })
    }
    // 审核
    auditClick(id: string | number) {
        if (!this.cannotEdit) {
            Vue.axios
                .post(
                    `vouchers/audit?id=${id}`, { a: 1 })
                .then(res => { this.fetchData() })
        }
    }
    // 点击凭证
    displayVoucher(voucher: Voucher.Voucher, isView: boolean) {
        if (isView) {
            this.editVoucher(voucher, true);
        } else {
            this.$set(voucher, "checked", !voucher.checked);

        }
    }
    // 修改凭证
    voucherShow: boolean = false;
    editVoucher(voucher: any, isView?: boolean) {
        if (!this.cannotEdit) {
            this.voucherShow = true;
            this.$nextTick(function () {
                let newVoucher: any = this.$refs.newVoucher;
                newVoucher.isDialog = true;
                newVoucher.shouldGetInit = false;
                newVoucher.isEdit = true;
                newVoucher.isInsert = 0;
                newVoucher.isCheck = false;
                newVoucher.showSaveAndAdd = false;
                newVoucher.showAdd = false;
                if (isView) newVoucher.notEdit = true;
                else newVoucher.notEdit = false;
                newVoucher.getSubjectList(null, () => {
                    newVoucher.packVoucher(voucher);
                });
            });
        }
    }
    //关闭凭证模态框
    closeVoucherDialog() {
        this.fetchData();
    }
    //销项发票/进项发票切换
    purchase: boolean = true
    changeIncoiceType(index: number) {
        if (index == 0) {
            this.purchase = true;
        } else {
            this.purchase = false;
        }
        this.fetchData();
    }
    // 智能合并
    isMerge: boolean = false;
    // 判断是否智能合并
    getMerge(type: string) {
        for (let i = 0; i < this.list.length; i++) {
            // @ts-ignore
            if (this.list[i][type].length > 1) return true;
        }
        return false;
    }
    changeMerge(isOpen: boolean) {
        let url = ""
        if (isOpen) url = "merge"
        else url = "remerge"
        Vue.axios
            .post(
                `vouchers/` + url + `/auto?accountBookId=${this.$store.state.accountBook.id}&period=${this.period}&cate=${this.cate}`, { nothing: "" })
            .then(res => { this.fetchData() })
    }

    searchQuery = "";
}
